export default "__VITE_ASSET__Bhz$xS4X__"